export default __webpack_public_path__ + "assets/images/turtle-blue-09768e84c2ae62788739c26a345cce89.svg";